import tryLogo from "@/assets/try-logo.jpg";

export const Footer = () => {
  return (
    <footer className="border-t border-border bg-card py-2 sm:py-3 md:py-4 px-3 sm:px-4 md:px-6 safe-area-bottom">
      <div className="flex items-center justify-between gap-2">
        <p className="text-[10px] sm:text-xs text-muted-foreground truncate">
          © 2025 Madelmold<span className="hidden sm:inline"> - Plásticos Técnicos</span>
        </p>
        
        <div className="flex items-center gap-1 sm:gap-2 flex-shrink-0">
          <span className="text-[10px] sm:text-xs text-muted-foreground hidden xs:inline">by</span>
          <img 
            src={tryLogo} 
            alt="Try! Company" 
            className="h-5 sm:h-6 md:h-8 w-auto object-contain"
          />
        </div>
      </div>
    </footer>
  );
};
